export default {
  profile: {
    name: 'OneChart',
    phone: '801.555.5555',
    address: {
      line1: '555 Cherry Lane',
      line2: '',
      city: 'American Fork',
      state: 'UT',
      zip: '82703'
    }
  },
  version: '1.0.0',
  providedBy: 'Provided by',
  links: {
    support: {
      label: 'Support',
      href: 'https://zendesk.com'
    },
    signout: {
      label: 'Sign Out',
      href: ''
    },
    account: {
      label: 'Account',
      href: ''
    }
  },
  patients: {
    title: 'Profiles',
    addProfile: 'Add Profile',
    pending: 'Pending invites',
    remove: 'Remove',
    viewDetails: 'View Chart'
  },
  providers: {
    addProvider: 'Add Provider',
    changePatient: 'Change Patient',
    selectProvider: 'Select Provider',
    newRequest: 'New Request',
    request: 'Select',
    share: 'Share with provider'
  },
  request: {
    requestRecordsFor: 'Records Request',
    fromProvider: 'Requesting records from:',
    recordsFromDate: 'How far back would you like to request records?',
    signature: 'Sign here to authorize this request.',
    signatureDesc:
      'Signing below will append your signature to the medical records request. Sign to continue.',
    submitRequest: 'Submit request',
    fallback: "Can't find your provider?",
    providerInfoForm: 'Provider information form',
    infoOnProvider: 'Please enter the name and address of your provider...'
  },
  label: {
    provider: 'Provider',
    patient: 'Patient',
    requestDate: 'Request records since date',
    patients: 'Patient Charts',
    edit: 'Edit',
    remove: 'Remove',
    requestRecords: 'Request records',
    typeSearch: 'Search',
    shareProviders: 'Share providers...',
    records: 'Records'
  },
  auth: {
    authorization: 'AUTHORIZATION',
    medicalRecords: 'Medical records for the office of:',
    notice:
      'CONFIDENTIALITY NOTICE -- This secure portal contains confidential information, some or all of which may be protected health information as defined by the federal Health Insurance Portability & Accountability Act (HIPAA) Privacy Rule. This portal is intended for the exclusive use of the individual or entity to whom it is addressed and may contain information that is proprietary, privileged, confidential and/or exempt from disclosure under applicable law. If you are not the intended recipient (or an employee or agent responsible for delivering the linked information to the intended recipient), you are hereby notified that any disclosure, dissemination, distribution or copying of this information is strictly prohibited and may be subject to legal restriction or sanction. Please notify the sender by telephone (number listed above) to arrange the return or destruction of the information and all copies.',
    agreement:
      'I certify that I am a member of the staff at the above named practice',
    sendResetPasswordContent:
      'You are required to reset your password, a link will be sent to the following email address...',
    sendResetPasswordSent:
      'A link has been sent to your email address, please check your inbox now.',
    sendResetPassword: 'Send reset password',
    noEmail: 'No email on record'
  },
  share: {
    shareWith: 'Share Records',
    selectFilesToShare: 'Select the files you want to share...',
    forPatient: 'For the patient...',
    message: 'Type a message for the recipients...',
    addRecipients: 'Add recipient',
    enterEmail: 'Enter recipient email...',
    emailPerson: 'Share by email  '
  },
  signup: {
    complete: 'Complete Profile'
  },
  files: {
    sending: 'Verifying the provider contact info.',
    sent: 'This request has been sent.',
    missingProvider: 'OneChart is processing your feedback.',
    search: 'Search',
    noRequests: 'No current pending requests',
    noRecords:
      "This chart is empty. Click 'Request Records' to add to this chart"
  }
}



// WEBPACK FOOTER //
// ./src/i18n/en.js